module.exports = __webpack_public_path__ + "img/icon2.c521fac0.png";